import { fetchWithAuth } from './auth';

export interface MeInfo {
  user_id: string;
  name: string | null;
  email: string | null;
  org_id: string;
  org_name: string | null;
  role: string;
  is_admin: boolean;
}

export async function getMe(): Promise<MeInfo> {
  const r = await fetchWithAuth('/api/field/settings/me');
  if (!r.ok) throw new Error(`getMe: ${r.status}`);
  return (await r.json()) as MeInfo;
}

export interface DeletePermissionsInfo {
  allow_inspector_delete: boolean;
  updated_at: string | null;
}

export async function getDeletePermissions(): Promise<DeletePermissionsInfo> {
  const r = await fetchWithAuth('/api/field/settings/delete-permissions');
  if (!r.ok) throw new Error(`getDeletePermissions: ${r.status}`);
  return (await r.json()) as DeletePermissionsInfo;
}

export async function putDeletePermissions(
  allow: boolean,
): Promise<DeletePermissionsInfo> {
  const r = await fetchWithAuth('/api/field/settings/delete-permissions', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ allow_inspector_delete: allow }),
  });
  if (!r.ok) {
    throw new Error(
      `putDeletePermissions: ${r.status}: ${(await r.text()).slice(0, 200)}`,
    );
  }
  return (await r.json()) as DeletePermissionsInfo;
}
